// /* eslint-disable max-len */
import { useMutation, UseMutationOptions } from 'react-query';

import {
  getTransactionsDetailsCsvReport,
} from '@zero5/payment-api';


type Response = string;
type Params = {
  from: number;
  until: number;
};

const useTransactionsDetailsReportCsvMutation = (
  options?: UseMutationOptions<Response, Error, Params, string>,
) => {
  return useMutation(
    'getTransactionsDetailsReportCsv',
    async (params) => {
      const response = await getTransactionsDetailsCsvReport(params);

      return response.report;
    },
    options,
  );
};

export default useTransactionsDetailsReportCsvMutation;
